import "./App.css";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import SuccessPage from "./components//Pages/SuccessPage";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import SoftwareDevelopment from "./components/Services/SoftwareDevelopment";
import AutomationServices from "./components/Services/AutomationServices";
import AIAutomation from "./components/Services/AIAutomation";
import AIGovernance from "./components/Services/AIGovernance";
import AzureGovernance from "./components/Services/AzureGovernance";
import MicrosoftAzureServices from "./components/Services/MicrosoftAzureServices";
import UseCasesPage from "./components/UseCases/UseCasesPage";
import UseCaseDetail from "./components/UseCases/UseCaseDetail";
import About from "./components/About/About";
import PrivacyPolicy from "./components/Privacy/PrivacyPolicy";

function ScrollToRouteTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        document.querySelector(location.hash)?.scrollIntoView({ behavior: "auto" });
      }, 0);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToRouteTop />
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route
          path="/services/software-development"
          element={<SoftwareDevelopment />}
        />
        <Route path="/services/azure" element={<MicrosoftAzureServices />} />
        <Route path="/services/automation" element={<AutomationServices />} />
        <Route path="/services/ai-automation" element={<AIAutomation />} />
        <Route path="/services/ai-governance" element={<AIGovernance />} />
        <Route path="/services/azure-cloud" element={<AzureGovernance />} />
        <Route path="/use-cases" element={<UseCasesPage />} />
        <Route path="/use-cases/:slug" element={<UseCaseDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
